import React from 'react';

export const ExclamationCircle = (props: any) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_861_1282)">
      <path
        d="M8 0C3.58065 0 0 3.6129 0 8C0 12.4194 3.58065 16 8 16C12.3871 16 16 12.4194 16 8C16 3.6129 12.3871 0 8 0ZM8 14.4516C4.41935 14.4516 1.54839 11.5806 1.54839 8C1.54839 4.45161 4.41935 1.54839 8 1.54839C11.5484 1.54839 14.4516 4.45161 14.4516 8C14.4516 11.5806 11.5484 14.4516 8 14.4516ZM9.35484 11.0968C9.35484 10.3548 8.74194 9.74194 8 9.74194C7.22581 9.74194 6.64516 10.3548 6.64516 11.0968C6.64516 11.871 7.22581 12.4516 8 12.4516C8.74194 12.4516 9.35484 11.871 9.35484 11.0968ZM6.70968 4.29032L6.93548 8.67742C6.93548 8.87097 7.12903 9.03226 7.32258 9.03226H8.64516C8.83871 9.03226 9.03226 8.87097 9.03226 8.67742L9.25806 4.29032C9.25806 4.06452 9.09677 3.87097 8.87097 3.87097H7.09677C6.87097 3.87097 6.70968 4.06452 6.70968 4.29032Z"
        fill="#171717"
      />
    </g>
    <defs>
      <clipPath id="clip0_861_1282">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
